import type { FC, ReactNode } from 'react';

import { cn } from '@shared/utils';

interface ErrorStateProps {
  display?: ReactNode;
  title: string;
  description: string;
  children?: ReactNode;
  className?: string;
}

export const ErrorState: FC<ErrorStateProps> = ({ display, title, description, children, className }) => (
  <div className={cn('flex min-h-[400px] flex-col items-center justify-center px-4 py-16 text-center', className)}>
    {display !== undefined && (
      <h1 className="text-9xl font-extrabold tracking-tight text-muted-foreground/20">{display}</h1>
    )}
    <h2 className="mt-4 text-3xl font-bold tracking-tight sm:text-5xl">{title}</h2>
    <p className="mt-6 max-w-md text-base leading-7 text-muted-foreground">{description}</p>
    {children}
  </div>
);
